import React from 'react';
import PropTypes from 'prop-types';
import { saveCookieConsent } from '../../utils/cookie';

const Prompt = props => {
  const { styles: s, bottom, isLoginPage, onClose, onConsent } = props;
  return (
    <div
      className={s.cookiePrompt}
      style={{ bottom, height: isLoginPage ? '120px' : 'auto' }}
    >
      {!isLoginPage && <span onClick={onClose} className="mdi mdi-close" />}
      <p>
        This website uses cookies to improve user experience. By continuing to
        browse this website, you declare to accept the use of cookies. For more
        information visit our{' '}
        <a href="/legal/cookie-policy" target="_blank">
          Privacy Policy
        </a>
      </p>
      {isLoginPage && <button onClick={onConsent}> Accept all cookies </button>}
    </div>
  );
};

class CookiePrompt extends React.Component {
  static propTypes = {
    isLoginPage: PropTypes.bool,
  };

  static defaultProps = {
    isLoginPage: false,
  };

  constructor(props) {
    super();
    this.state = {
      isLoginPage: props.isLoginPage,
      bottom: '-40vh',
      showCookiePrompt: true,
    };
  }

  componentDidMount() {
    const time = this.state.isLoginPage ? 0 : 5000;
    setTimeout(() => {
      this.setState({ bottom: '0' });
    }, time);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoginPage) {
      this.setState({
        isLoginPage: nextProps.isLoginPage,
        showCookiePrompt: true,
      });
    }
  }

  animateHideCookie = () => {
    this.setState(
      {
        bottom: '-40vh',
      },
      () => {
        setTimeout(() => {
          this.hideCookie();
        }, 300);
      },
    );
  };

  saveConsent = () => {
    saveCookieConsent(true);
    this.setState({ showCookiePrompt: false });
    this.props.saveConsent();
  };

  hideCookie = () => {
    this.setState({ showCookiePrompt: false });
  };

  render() {
    const { styles: s } = this.props;

    const { bottom, isLoginPage, showCookiePrompt } = this.state;

    if (!showCookiePrompt) {
      return null;
    }

    return (
      <div
        className={s.cookiePromptContainer}
        style={{
          height: isLoginPage ? '100vh' : 'auto',
          // padding: '10px',
        }}
      >
        {isLoginPage && <div className={s.cookieOverlay} />}
        <Prompt
          styles={s}
          bottom={bottom}
          onClose={this.hideCookie}
          onConsent={this.saveConsent}
          isLoginPage={isLoginPage}
        />
      </div>
    );
  }
}

export default CookiePrompt;



// WEBPACK FOOTER //
// ./src/components/Layout/CookiePrompt.js